import cn from 'classnames';
import { useEffect, useState } from 'react';
import { ChevronDoubleLeftIcon } from '@heroicons/react/24/outline';
import Navigation from './Navigation';

function Sidebar({ navigation }) {
  const [isCompact, setCompact] = useState(false);
  const [scrollY, setScrollY] = useState(0);

  const handleCompactToggle = () => {
    setCompact((previous) => !previous);
  };

  const handleScroll = () => {
    const newScrollY = window.scrollY;
    if (scrollY < 64) {
      setScrollY(Math.min(newScrollY, 64));
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      className={cn(
        'hidden md:flex md:flex-col md:sticky top-0 h-2/4',
        {
          'md:w-16': isCompact,
          'md:w-64': !isCompact,
        },
        'transition-[width] overflow-x-hidden',
      )}
      style={{
        height: `calc(100vh - 64px + ${scrollY}px)`,
      }}
    >
      <div className="flex-1 flex flex-col min-h-0 border-r border-gray-200 bg-white">
        <div className="flex-1 flex flex-col pt-5 pb-4 overflow-y-auto overflow-x-hidden">
          <Navigation compact={isCompact} navigation={navigation} />
        </div>
        <div className="text-center">
          <div
            className="inline-block cursor-pointer p-2"
            onClick={handleCompactToggle}
          >
            <ChevronDoubleLeftIcon
              className={cn(
                'cursor-pointer w-4 h-4 text-gray-500 hover:text-gray-600 transition-transform',
                {
                  'rotate-180': isCompact,
                },
              )}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
